import { AnalyticsService } from './../analytics/analytics.service';
import { FormControl } from '@angular/forms';
import { UnsplashImageService } from './../unsplash/unsplash.service';
import { Urls } from './../unsplash/unsplash.response';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';
import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, OnDestroy, ElementRef, ViewChild, HostListener } from '@angular/core';
import { Result } from '../unsplash/unsplash.response';
import { RegistryService } from '../registry/registry.service';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute } from '@angular/router';
import { Image, ImageResults } from '../unsplash/image-results';
import { ImageUrlService } from '../shared/services/image-url.service';

@Component({
  selector: 'app-header-background-popup',
  templateUrl: './header-background-popup.component.html',
  styleUrls: ['./header-background-popup.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  host: {
    '(document:keydown)': 'handleKeyboardEvents($event)'
  }
})


export class HeaderBackgroundPopupComponent implements OnInit, OnDestroy {
  @ViewChild('serachQuery') firstNameElement: ElementRef;
  hide: boolean;

  @Output() headerPopupEvent: EventEmitter<any>;
  featchingMoreImages = false;
  public imageQuery: string;
  @Input() showPopup = false;
  
  imageResults: ImageResults;
  images: Image[];
  public selectedImageUrl: string;
  public selecting = false;
  public loadingImages: boolean;
  public loadingMore = false;
  searchType = 'images';
  public backgroundIamge: string;
  public queryText = '';
  public showQuery = true;
  public noMorePages = false;
  eventTarget: any;
  targetScroll = 0;
  uploading = false;
  public pageNo = 1;
  public subject: Subject<string> = new Subject();
  constructor(private _unsplashImageService: UnsplashImageService,
    private _registryService: RegistryService,
    private router: Router,
    private _registryFirebaseService: RegistryFirebaseService,
    private _analyticsService: AnalyticsService,
    private imageUrlService: ImageUrlService
  ) {
    this.headerPopupEvent = new EventEmitter<any>();
    
    this.pageNo = 1;

    
  }
  // @HostListener('scroll', ['$event'])
  onScroll(event) {


    if(this.queryText == "Hitchd Collection")
    {
      return;
    }

    // const endOfPage =
    // window.innerHeight + window.pageYOffset >= document.body.offsetHeight;
    // if (endOfPage) {

    if(((event.target.scrollTop +  event.target.offsetHeight)) >= (event.target.scrollHeight * 0.8)){

      if( this.featchingMoreImages ){
        return;
      }
      this.targetScroll = event.target.scrollTop +  event.target.offsetHeight;
      this.eventTarget = event.target;
      this.featchingMoreImages = true
      this.loadMore();

     // addCards(currentPage + 1);
    }
  }

  

  handleKeyboardEvents(event: any) {
    if (this.showPopup && event.keyCode === 27) {

      this.close();
    }

  }

  focus() {
    this.firstNameElement.nativeElement.focus();
    this.top();
  }

  handleUploadingImage(event: any) {
    this.uploading = true;
  }

  handledUploadedImage(event: any) {

    if (event) {
      event = event + '?hex=ffffff';

      this.selectedImageUrl = event;
      this._registryFirebaseService.UpdateHeaderBackgroundImage(this.selectedImageUrl, null);
      this.uploading = false;

      this.showPopup = false;
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = 'auto';
      this._registryService.emitHeaderPopupClosed();
      window.scrollTo(0, 0);
      this._analyticsService.trackEvent('Uploaded header image', {url: this.selectedImageUrl});
      this._analyticsService.trackEvent('Updated header image', {url: this.selectedImageUrl});
    }
  }


  onEnter() {
    document.getElementById('imagesearch').blur();
  }


  ngOnDestroy() {

  }

  onKeyUp(searchTextValue: string) {
    this.queryText = ' ';
    this.showQuery = false;
    this.images = null;
    this.imageResults = null;
    this.subject.next(searchTextValue);
  }

  setImageViaUrl(imageUrl: string) {
    this._registryFirebaseService.UpdateHeaderBackgroundImage(imageUrl, null);
    this.showPopup = false;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    window.scrollTo(0, 0);
  }

  setImage(selectedImage: Image) {
    this.selecting = true;


    this.selectedImageUrl = selectedImage.imageUrl.split('?')[0] + '?hex=' + selectedImage.color;
//TODO: SET downloadlocation for unsplash only
    if (selectedImage.analyticsUrl) {
      this._unsplashImageService.SendDownloadRequest(selectedImage.analyticsUrl);
    }

    this._registryService.sendFbTrackEvent('Change registry header image');

    if(this._registryFirebaseService.isAnonRegPath()){
      let reg  = this._registryFirebaseService.getAnonRegistry();
      reg.backgroundHeaderImageUrl = this.selectedImageUrl;
      this._registryFirebaseService.saveAnonRegistry(reg)
      this.close();
      return;
     } else {

      let videoUrl = selectedImage.videoUrlHd? selectedImage.videoUrlHd: selectedImage.videoUrl;
    this._registryFirebaseService.UpdateHeaderBackgroundImage(this.selectedImageUrl, videoUrl);

     }

    this.showPopup = false;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    this._analyticsService.trackEvent('Updated header image', {url: this.selectedImageUrl});
    window.scrollTo(0, 0);
  }
  scroll() {
    document.getElementById('imagesearch').blur();
  }


 


  top() {
    document.body.scrollTop = 0;
    document.getElementsByClassName('modal-backdrop')[0].scrollTop = 0;
  }


  openUploader() {
    if(this._registryFirebaseService.isAnonRegPath()){
      this._registryService.emitGenricPopup('anon_signup');
    } else {
    document.getElementById('file_input_id').click();
    }
  }

  arrayUnique(array: Result[]) {
    const a = array.concat();
    for (let i = 0; i < a.length; ++i) {
      for (let j = i + 1; j < a.length; ++j) {
        if (a[i].id === a[j].id) {
          a.splice(j--, 2);
        }
      }
    }

    return a;
  }
  toggleVideo(videoImage: Image) {

    var videobuttons: any = document.getElementsByClassName('video_button');

    var videos: any = document.getElementsByClassName('pexels_video');
    var pausebuttons: any = document.getElementsByClassName('paused');
    var playingButtons: any = document.getElementsByClassName('playing');
    if (videobuttons) {
      Array.from(videobuttons).forEach(element => {
        (element as any).style.display = "none";

      });
    }
    if (pausebuttons) {
      Array.from(pausebuttons).forEach(element => {
        (element as any).style.display = "block";

      });
    }

    if (playingButtons) {
      Array.from(playingButtons).forEach(element => {
        (element as any).style.display = "none";

      });
    }







    var videoPlayer: any = document.getElementById(videoImage.videoUrl);

    var addButton: any = document.getElementById(videoImage.videoUrl + '_add');
    var currentPausebutton: any = document.getElementById(videoImage.videoUrl + '_pause_button');
    var currentPlayButton: any = document.getElementById(videoImage.videoUrl + '_play_button');
    if (videoPlayer.paused) {
      if (videos) {
        Array.from(videos).forEach(element => {

          (element as any).pause();
       //     (element as any).classList.add("paused");
        });
      }

      videoPlayer.play();

      if (currentPausebutton) {
        (currentPausebutton as any).style.display = "block";
      }
      if (currentPlayButton) {
        (currentPlayButton as any).style.display = "none";
      }
      if (addButton) {
        (addButton as any).style.display = "block";
      }

    }
    else {
      videoPlayer.pause();
      if (currentPausebutton) {
        (currentPausebutton as any).style.display = "none";
      }
      if (currentPlayButton) {
        (currentPlayButton as any).style.display = "block";
      }
      if (addButton) {
        (addButton as any).style.display = "none";
      }

    }
    // videoPlayer.classList.add("playing");


  }

  findImages(clearQuery: boolean, skipLoadingState: boolean = true) {


    localStorage.setItem('gift-assistant-search', this.imageQuery);

    this.loadingImages = skipLoadingState;
    let collectionId = '';
    if (!this.imageQuery) {
      collectionId = '1085865';
    }
    if (this.imageQuery.toLowerCase().startsWith('https://images.unsplash.com/photo')) {
      this.setImageViaUrl(this.imageQuery);
    }
    //     = a.concat(b.filter(function (item) {
    //     return a.indexOf(item) < 0;
    // }))

    if(clearQuery){
    this.images = null;
    }
    this._unsplashImageService.GetUnsplashImages(this.imageQuery, this.pageNo, collectionId, this.searchType=='loops').subscribe(imageResults=>{
    
     if(this.images && this.pageNo > 1){
      this.images = this.images.concat(imageResults); 
     } else {
      this.images = imageResults;
     }
       
      this.queryText = this.imageQuery;
      this.loadingMore = false;
      // if (imageResults.total_pages <= this.pageNo) {
      //   this.noMorePages = true;
      // } else {
      //   this.noMorePages = false;
      // }
      this.loadingImages = false;

      if (clearQuery) {
        this.imageQuery = '';
      }

      if (collectionId) {

        this.queryText = 'Hitchd Collection';
      }

      if(this.featchingMoreImages){
 
        this.featchingMoreImages  = false;

      }

     
    })

    // this._unsplashImageService.GetImages(this.imageQuery, this.pageNo, collectionId).subscribe(x => {
    //   if (this.pageNo > 1) {

    //     this.unSplashImages = this.arrayUnique(this.unSplashImages = this.unSplashImages.concat(x.results));

    //   } else {
    //     this.unSplashImages = x.results;
    //   }
    //   this.queryText = this.imageQuery;

    //   this.loadingMore = false;
    //   if (x.total_pages <= this.pageNo) {
    //     this.noMorePages = true;
    //   } else {
    //     this.noMorePages = false;
    //   }
    //   this.loadingImages = false;

    //   if (clearQuery) {
    //     this.imageQuery = '';
    //   }

    //   if (collectionId) {

    //     this.queryText = 'Hitchd Collection';
    //   }
    // });

  }

  clearQuery() {
    this.imageQuery = '';
    this.onKeyUp('');
    document.getElementById('imagesearch').focus();
  }

  resetSearch() {
    this.imageQuery = '';
  }
  ngOnInit() {



    this.subject.debounceTime(800).subscribe(searchTextValue => {
      this.pageNo = 1;
      this.showQuery = true;
      this.imageResults = null;
      this.images = null;
      this.findImages(false);
    });

    this._registryService.showHeaderTypeEmitted$.subscribe(x => {

      this.showPopup = true;
      const body = document.getElementsByTagName('body')[0];
      //
      body.style.overflow = 'hidden';
    });

    this.imageQuery = '';

    this.findImages(true);

  }

  loadMore() {
    this.pageNo = this.pageNo + 1;
    this.loadingMore = true;
    if (this.imageQuery === '' || this.imageQuery === undefined) {
      this.imageQuery = '';
    }
    this.findImages(false, false);
  }


  close() {
    if(!this.showPopup) {
      return;
    }
    console.log('headerbackgrount component') //    
    this.showPopup = false;
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    this.headerPopupEvent.emit('close');
    this._registryService.emitHeaderPopupClosed();
  }

  getStandardImageUrl(imageUrl: string): string {
    return this.imageUrlService.getStandardImageUrl(imageUrl);
  }
}



// WEBPACK FOOTER //
// ./src/app/header-background-popup/header-background-popup.component.ts